import EventTracker from "../../../utils/EventTracker";
import CONSTANTS from "./constants";

const resolveAxis = (val, camera, sprite) => {
    let [constant, percent = 0] = val.split(".");
    switch (constant) {
      case "C":
        return camera * (0.5 + percent / 100);
      case "R":
      case "B":
        return camera * (1 - percent / 100) - sprite / 2 + 3;
      case "L":
      case "T":
        return 0 + sprite / 2 + camera * (percent / 100);
      default:
        return 0;
    }
  },
  resolvePoint = (val, camera) => {
    let [constant, percent = 0] = val.split(".");
    switch (constant) {
      case "C":
        return camera * (0.5 + percent / 100);
      case "R":
      case "B":
        return camera * (1 - percent / 100);
      case "L":
      case "T":
        return camera * (percent / 100);
      default:
        return 0;
    }
  },
  resolveScale = (width, height) => {
    if (width > 600 && height > 300) return 1;
    else {
      let { WIDTH, HEIGHT } = CONSTANTS,
        widthScale = width / WIDTH,
        heightScale = height / HEIGHT;
      return widthScale > heightScale ? widthScale : heightScale;
    }
  },
  resolveFontScale = (width, height) => {
    if (width > 800 && height > 400) return 1;
    else if (width > 600 && height > 300) return 0.8;
    else return resolveScale(width, height);
  };

const addSprite = (scene, key, position, scale = {}, frame = null) => {
    let { width, height } = scene.camera,
      texture = scene.textures.get(key),
      { width: spriteWidth, height: spriteHeight } =
        texture.frameTotal === 1 ? texture.get("__BASE") : texture.get("0"),
      { x, y } = position,
      { x: scaleX, y: scaleY, factor: scaleFactor = 1 } = scale,
      fitFactor = resolveScale(width, height);
    let X = resolveAxis(x, width, spriteWidth * fitFactor),
      Y = resolveAxis(y, height, spriteHeight * fitFactor),
      sprite = scene.add.sprite(X, Y, key, frame);
    if (scaleX) sprite.scaleX = scaleFactor;
    if (scaleY) sprite.scaleY = scaleFactor;
    sprite.setScale(fitFactor);
    return sprite;
  },
  addSpriteWithText = (scene, key, position, scale = {}, text, max = 5) => {
    let { width, height } = scene.camera,
      texture = scene.textures.get(key),
      { width: spriteWidth, height: spriteHeight } =
        texture.frameTotal === 1 ? texture.get("__BASE") : texture.get("0"),
      { x, y } = position,
      fitFactor = resolveScale(width, height),
      sprite = scene.add.sprite(0, 0, key),
      labelObject = scene.add
        .text(
          0,
          0,
          text ? text.slice(0, max) + (text.length > max ? "..." : "") : "",
          {
            fontFamily: "AvenirNext",
            color: "#000000",
            align: "center",
          }
        )
        .setFontSize(14 * resolveFontScale(width, height))
        .setOrigin(0.5, 0.5),
      X = resolveAxis(x, width, spriteWidth * fitFactor),
      Y = resolveAxis(y, height, spriteHeight * fitFactor);
    sprite.setScale(fitFactor);
    let container = scene.add.container(X, Y, [sprite, labelObject]);
    container.setSize(spriteWidth * fitFactor, spriteHeight * fitFactor);
    return container;
  },
  addInfoOverlay = (scene, key, text) => {
    if (scene.overlay && !scene.overlay[key]) {
      let container = addSpriteWithText(
          scene,
          key,
          { x: "C", y: "C" },
          {},
          text,
          200
        ),
        fitFactor = resolveScale(scene.camera.width, scene.camera.height),
        close = addSprite(
          scene,
          "close",
          fitFactor === 1
            ? { x: "C.25", y: "C.-12" }
            : { x: "C.18", y: "C.-10" }
        ),
        backdrop = addSprite(scene, "backdrop", { x: "C", y: "C" }),
        layer = scene.add.layer();
      close.setInteractive();
      close.on("pointerdown", () => {
        scene.overlay[key] = false;
        layer.destroy();
      });
      layer.add(backdrop);
      layer.add(container);
      layer.add(close);
      scene.overlay[key] = true;
    }
  },
  addLabel = (scene, position, size, text, color, font, bold) => {
    let { width, height } = scene.camera,
      { x, y } = position,
      X = resolvePoint(x, width),
      Y = resolvePoint(y, height),
      labelObject = scene.add
        .text(0, 0, text, {
          fontFamily: font,
          color,
          align: "center",
        })
        .setFontSize(size * resolveFontScale(width, height))
        .setOrigin(0.5, 0.5);
    if (bold) labelObject = labelObject.setStroke(color, 1.5);
    return scene.add.container(X, Y, [labelObject]);
  },
  addDialogue = (scene, spriteMap, dialogue) => {
    let { sprite, position, text, color, size, delay, end } = dialogue,
      { width, height } = scene.camera,
      texture = scene.textures.get(sprite),
      { width: spriteWidth, height: spriteHeight } =
        texture.frameTotal === 1 ? texture.get("__BASE") : texture.get("0"),
      fitFactor = resolveScale(width, height),
      X = resolveAxis(position.x, width, spriteWidth * fitFactor),
      Y = resolveAxis(position.y, height, spriteHeight * fitFactor),
      spriteObject = scene.add.sprite(0, 0, sprite),
      labelObject = scene.add
        .text(0, 0, "", {
          fontFamily: "AvenirNext-Regular",
          color,
          align: "center",
        })
        .setFontSize(size * resolveFontScale(width, height))
        .setOrigin(0.5, 0.5),
      index = 0,
      length = text.length;
    spriteObject.setScale(fitFactor);
    scene.time.addEvent({
      callback: () => {
        labelObject.text += text[index];
        ++index;
        if (index === length - 1) {
          let { action, show = [], hide = [] } = end,
            i;
          if (action === "TOGGLE") {
            for (i = 0; i < show.length; i++)
              spriteMap[show[i]].setVisible(true);
            for (i = 0; i < hide.length; i++)
              spriteMap[hide[i]].setVisible(false);
          }
        }
      },
      repeat: length - 1,
      delay,
    });
    return scene.add.container(X, Y, [spriteObject, labelObject]);
  },
  resolveText = (text, length) => {
    let words = text.split(" "),
      count = 0;
    return words.reduce((prev, current) => {
      if (count + current.length > length) {
        count = 0;
        return prev + "\n " + current;
      }
      count += current.length;
      return prev + " " + current;
    }, "");
  },
  addScrollContainer = (
    scene,
    data,
    kind,
    position,
    dimensions,
    X = 0,
    Y = 0
  ) => {
    let { x, y } = position,
      { w } = dimensions,
      { width, height } = scene.camera,
      containers = [],
      fitFactor = resolveScale(width, height);
    switch (kind) {
      case "RECOMMENDATIONS":
        data.map((entry, index) => {
          let element = scene.add.sprite(0, 0, "recommendation"),
            title = scene.add
              .text(-120, -40, resolveText(entry.title, 16), {
                fontFamily: "AvenirNext-Regular",
                color: "#000000",
              })
              .setFontSize(14)
              .setOrigin(0, 0),
            kind = scene.add
              .text(35, 16, entry.kind, {
                fontFamily: "AvenirNext-Regular",
                color: "#000000",
              })
              .setFontSize(14)
              .setOrigin(0, 0),
            details = scene.add.sprite(100, -20, "details").setOrigin(0.5, 0.5),
            container = scene.add.container(x, (index + 1) * y, [
              element,
              title,
              kind,
              details,
            ]);
          container.index = index;
          container.setSize(element.width, element.height);
          container.setInteractive();
          details.setInteractive();
          details.on("pointerdown", () => {
            let { kind, slug } = entry,
              path = "";
            EventTracker.instance.trackEvent("Open Game Recommendations", {
              Feature: kind,
              Description: slug,
              "Previous-Screen": scene.screen_name,
            });
            if (scene.bgm.isPlaying) scene.bgm.pause();
            if (kind === "EMOTION") path = `emotions/${slug}`;
            else if (kind === "GUIDE") path = `guides/${slug}`;
            else if (kind === "HABIT") path = "habits/add";
            else if (kind === "JOURNAL") path = "journal";
            scene.history.replace(`/${path}`);
            window.location.href = `/${path}`;
          });
          containers.push(container);
          return null;
        });
        break;
      case "PAST_MONTHLY":
        Object.keys(data)
          .sort((a, b) => b.localeCompare(a))
          .map((entry, index) => {
            if (index === 0 && scene.activities && !scene.activities.month) {
              scene.activities.month = entry;
              if (data[entry][scene.activities.kind].length === 0) {
                scene.activities.kind = "recommended";
              }
            }
            let circle = scene.add.circle(
                0,
                0,
                w,
                scene.activities.month === entry ||
                  (!scene.activities.month && index === 0)
                  ? "0x016876"
                  : "0x0AB5CD"
              ),
              text = scene.add
                .text(0, 0, data[entry].text, {
                  fontFamily: "monospace",
                  color: "#000000",
                  align: "center",
                })
                .setFontSize(18 * fitFactor)
                .setOrigin(0.5, 0.5)
                .setStroke("#000000", 1.5),
              container = scene.add.container(
                x,
                index === 0 ? y : -(index - 1) * y,
                [circle, text]
              );
            container.index = index;
            container.key = "MONTH";
            container.selected =
              scene.activities.month === entry ||
              (!scene.activities.month && index === 0);
            container.setSize(circle.radius * 2, circle.radius * 2);
            container.setInteractive();
            containers.push(container);
            return null;
          });
        if (scene.activities && scene.activities.kind) {
          let kind = scene.activities.kind,
            spriteMap = scene.spriteMap;
          if (kind === "clouds") {
            spriteMap.clouds_selected.setVisible(true);
            spriteMap.clouds.setVisible(false);
            spriteMap.recommended.setVisible(true);
            spriteMap.recommended_selected.setVisible(false);
          } else {
            spriteMap.clouds_selected.setVisible(false);
            spriteMap.clouds.setVisible(true);
            spriteMap.recommended.setVisible(false);
            spriteMap.recommended_selected.setVisible(true);
          }
        }
        break;
      case "PAST_CLOUDS":
        containers = [];
        if (data.length === 0) {
          let text = scene.add
            .text(0, 0, "No clouds found", {
              font: "monospace",
              color: "#000000",
              align: "center",
            })
            .setFontSize(18 * resolveFontScale(width, height))
            .setOrigin(0.5, 0.5);
          scene.add.container(width / 2, y, [text]);
        }
        data.map((entry, index) => {
          let cloud = scene.add.sprite(0, 0, "cloud"),
            cloudText = scene.add
              .text(0, 0, entry.slice(0, 5), {
                font: "monospace",
                color: "#000000",
                align: "center",
              })
              .setFontSize(18 * resolveFontScale(width, height))
              .setOrigin(0.5, 0.5),
            details = scene.add
              .sprite(100 * fitFactor, 0, "details")
              .setOrigin(0.5, 0.5),
            container = scene.add.container(x, (index + 1) * y, [
              cloud,
              cloudText,
              details,
            ]);
          container.index = index;
          container.key = "CLOUD";
          container.setSize(cloud.width, cloud.height);
          container.setInteractive();
          details.setInteractive();
          details.on("pointerdown", () => {
            addInfoOverlay(scene, "info", entry);
          });
          containers.push(container);
          return null;
        });
        break;
      case "PAST_RECOMMENDATIONS":
        break;
      default:
        return;
    }
    scene.input.setDraggable(containers);
    scene.input.on("drag", (position, gameObject, dragX, dragY) => {
      if (gameObject.key === containers[0].key) {
        let current = gameObject.index,
          pixels = dragY - gameObject.y;
        if (
          (current === 0 && dragY < gameObject.y) ||
          (current > 0 && current < containers.length - 1) ||
          (current === containers.length - 1 && dragY > gameObject.y)
        ) {
          for (let i = 0; i < containers.length; i++) {
            if (i !== current) {
              let r = containers[i];
              r.setPosition(r.x, r.y + pixels);
            }
          }
          gameObject.y = dragY;
        }
      }
    });
    return scene.add.container(X, Y, containers);
  },
  resolveAction = (scene, listener, key = null) => {
    let { action, value } = listener;
    switch (action) {
      case "TRAVEL":
        EventTracker.instance.trackEvent("Open Screen", {
          "Screen-Name":
            scene.data.game.game.screens[scene.step + value].screen,
          CTA: key,
          "Previous-Screen": scene.data.game.game.screens[scene.step].screen,
        });
        scene.step += value;
        break;
      case "RESET":
        EventTracker.instance.trackEvent("Open Screen", {
          "Screen-Name": scene.data.game.game.screens[0].screen,
          CTA: key,
          "Previous-Screen": scene.data.game.game.screens[scene.step].screen,
        });
        scene.pastScreen = null;
        scene.step = 0;
        break;
      case "RESUME":
        EventTracker.instance.trackEvent("Open Screen", {
          "Screen-Name": scene.data.game.game.screens[scene.data.step].screen,
          CTA: key,
          "Previous-Screen": scene.data.game.game.screens[scene.step].screen,
        });
        scene.step = scene.data.step;
        break;
      case "TRAVEL_INTRO":
        scene.step += value + (scene.recommendations.length > 0 ? 1 : 0);
        break;
      case "SHARE":
        navigator
          .share(scene.data.game.share)
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
        break;
      default:
        console.log("Unknown action");
    }
  },
  getBucketBox = (scene, sprite) => {
    let { width, height } = scene.camera,
      { x, y, flipX } = sprite,
      fitFactor = resolveScale(width, height),
      X1 = !flipX ? x - 51 * fitFactor : x,
      Y1 = y - 3 * fitFactor,
      X2 = X1 + 54 * fitFactor,
      Y2 = Y1 + 20 * fitFactor;
    return { X1, X2, Y1, Y2 };
  };

const methods = {
  addSprite,
  addSpriteWithText,
  addInfoOverlay,
  addLabel,
  addDialogue,
  addScrollContainer,
  getBucketBox,
  resolveAction,
  resolvePoint,
};

export default methods;
